// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hDdO","colBig":"styles_colBig__KSwJQ","colSmall":"styles_colSmall__4478X","shopifyNameWrapper":"styles_shopifyNameWrapper__2-udz"};